import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { 
    GetAllSenderEmails, 
    GetSenderEmailByID, 
    CreateSenderEmail, 
    UpdateSenderEmail, 
    DeleteSenderEmail, 
    GetDefaultSenderEmail, 
    SetDefaultSenderEmail 
} from "helpers/api_method";

export const getAllSenderEmails = createAsyncThunk("senderEmail/getAllSenderEmails", async () => {
    try {
        const response = await GetAllSenderEmails();
        return response;
    } catch (error: any) {
        toast.error(error.message || "Failed to fetch sender emails", { autoClose: 2000 });
        return error;
    }
});

export const getSenderEmailByID = createAsyncThunk("senderEmail/getSenderEmailByID", async (id: string) => {
    try {
        const response = await GetSenderEmailByID(id);
        return response.data;
    } catch (error: any) {
        toast.error(error.message || "Failed to fetch sender email", { autoClose: 2000 });
        return error;
    }
});

export const createSenderEmail = createAsyncThunk("senderEmail/createSenderEmail", async (data: any) => {
    try {
        const response = await CreateSenderEmail(data);
        toast.success("Sender email created successfully", { autoClose: 2000 });
        return response.data;
    } catch (error: any) {
        toast.error(error.message || "Failed to create sender email", { autoClose: 2000 });
        return error;
    }
});

export const updateSenderEmail = createAsyncThunk("senderEmail/updateSenderEmail", async ({ id, data }: { id: string, data: any }) => {
    try {
        const response = await UpdateSenderEmail(id, data);
        toast.success("Sender email updated successfully", { autoClose: 2000 });
        return response.data;
    } catch (error: any) {
        toast.error(error.message || "Failed to update sender email", { autoClose: 2000 });
        return error;
    }
});

export const deleteSenderEmail = createAsyncThunk("senderEmail/deleteSenderEmail", async (id: string) => {
    try {
        const response = await DeleteSenderEmail(id);
        toast.success("Sender email deleted successfully", { autoClose: 2000 });
        return { id, ...response.data };
    } catch (error: any) {
        toast.error(error.message || "Failed to delete sender email", { autoClose: 2000 });
        return error;
    }
});

export const getDefaultSenderEmail = createAsyncThunk("senderEmail/getDefaultSenderEmail", async () => {
    try {
        const response = await GetDefaultSenderEmail();
        return response.data;
    } catch (error: any) {
        toast.error(error.message || "Failed to fetch default sender email", { autoClose: 2000 });
        return error;
    }
});

export const setDefaultSenderEmail = createAsyncThunk("senderEmail/setDefaultSenderEmail", async (id: string) => {
    try {
        const response = await SetDefaultSenderEmail(id);
        toast.success("Default sender email updated successfully", { autoClose: 2000 });
        return response.data;
    } catch (error: any) {
        toast.error(error.message || "Failed to set default sender email", { autoClose: 2000 });
        return error;
    }
});
